import Text from '@/components/text';
import useThread from '@/hooks/use-thread.hook';
import useUserSettings from '@/hooks/use-user-settings.hook';
import { Box, Fade, Stack, Theme } from '@mui/material';
import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import AgentSelector from './agent-selector';
import Loader from '@/components/loader';
import OrgBadge from '@/components/org-badge';
import useThemeMediaQuery from '@/hooks/use-theme-media-query';

const useStyles = createUseStyles((theme: Theme) => ({
  threadOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 1,
    width: '100%',
    height: '100%',
    maxHeight: '100%',
    backgroundColor: theme.palette.background.default,
  },
  settingsLoader: {
    width: '80%',
  },
}));

const ThreadOverlay: FC = () => {
  const styles = useStyles();
  const { small } = useThemeMediaQuery();
  const { thread, loadState } = useThread();
  const { agents, isLoading: settingsLoading } = useUserSettings();

  const hasMessages = !!thread.conversation.length;
  const hasAgents = !!agents.length;
  const threadLoading = loadState !== 'loaded';
  const isLoading = settingsLoading || threadLoading;

  return (
    <>
      <Fade
        in={isLoading}
        className={styles.threadOverlay}
        mountOnEnter
        unmountOnExit
        timeout={150}
      >
        <Stack width="100%" height="100%" alignItems="center" justifyContent="center">
          {settingsLoading && <Loader className={styles.settingsLoader} />}
        </Stack>
      </Fade>
      {!isLoading && !hasMessages && (
        <Stack className={styles.threadOverlay} gap={3} alignItems="center" justifyContent="center">
          <Stack gap={2} alignItems="center" width="100%">
            {!hasAgents && (
              <>
                <OrgBadge />
                <Text>What would you like to get done today?</Text>
              </>
            )}
            {hasAgents && (
              <Box height="300px" width={small ? '90%' : '50%'}>
                <AgentSelector />
              </Box>
            )}
          </Stack>
        </Stack>
      )}
    </>
  );
};

export default ThreadOverlay;
